export default function isValidEmail(email: string): boolean {
  // Aceita usuário com pontos, subdomínios e TLD com 2+ caracteres
  const regex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  if(!regex.test(email)) {
    return false;
  }
  return true;
}